<template>
  <div class="flex-grow">

    <div class="messenger-container">

      <div
        :class="messengerLayout"
        >

        <TransitionGroup tag="div" name="fade" class="container" :class="conversationsClass" v-if="route.path.startsWith('/messenger/')">
          <div v-if="serverConfig.view != 'mobile'" class="chat-title">
            <h4>{{localize('TEXT_CHATS')}}</h4>
          </div>
          <div
            class="conversation-bubble"
            v-for="(k,i) in conversations"
            key="k.room_id"
            @click="selectedConversation = k.room_id"
          >
            <div
              class="bubble-container"
              v-for="(j,r) in k.users"
              key="j"
            >
              <div v-if="users[j]" class="user-profile-bubble">
                <img v-if="users[j].image" class="profile-image" :src="'../../' + users[j].image" />
                <img v-else class="profile-image" src="/public/defaultprofile.jpg" />
                <div v-if="serverConfig.view == 'desktop' || serverConfig.view == 'laptop'">
                  <div class="profile-text">
                    <b>{{ users[j].name }}</b>
                  </div>
                  <div class="profile-text">
                    {{ k.message?.text }}
                  </div>
                  <div class="active-conversation" v-if="selectedConversation == k.room_id" />
                </div>
              </div>
            </div>
          </div>
        </TransitionGroup>

        <div :class="messagesLayout">
          <div id="message-space">
            <div
              v-for="(k,i) in messages"
            >

              <div
                class="messages-container-bubble-me"
                v-if="k.user_id === userInfo.user_id"
              >
                <div
                  v-if="k.message?.mimeType"
                  class="message-file-me"
                  @click="downloadFile(k.message)"
                >
                  <div class="mime-type">
                    {{ k.message?.mimeType }}
                  </div>
                  <div class="file-name">
                    {{ k.message?.name }}
                  </div>
                </div>
                <div
                  v-else
                  class="message-bubble-me"
                  @click="toggleMessageOptions('msg-'+k.id)"
                >
                  <div
                    v-html="textToLinks(k.message?.text)"
                  />
                  <div :id="'msg-'+k.id" class="message-options" hidden>
                    <div @click="deleteMessage(k.id)">
                      delete
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="messages-container-bubble-other"
                v-else
              >
                <div
                  v-if="k.message?.mimeType"
                  class="message-file-other"
                  @click="downloadFile(k.message)"
                >
                  <div class="mime-type">
                    {{ k.message?.mimeType }}
                  </div>
                  <div class="file-name">
                    {{ k.message?.name }}
                  </div>
                </div>
                <div
                  v-else
                  class="message-bubble-other"
                  v-html="textToLinks(k.message?.text)"
                />
              </div>
            </div>
            <div
              v-if="sendingFile"
              class="sending-file-container"
            >
              <div
                class="sending-file-background"
              >
                <div
                  class="sending-file-text"
                >
                   {{ localize('TEXT_SENDING_FILE') }}
                </div>
              </div>
            </div>
          </div>

          <div class="message-input">
            <div class="message-input-left">
            </div>
            <div
              class="message-input-center"
            >
              <textarea
                class="message-input-field"
                type="text"
                placeholder="Hi .."
                v-model="inputValue"
                v-on:input="handleInput"
                @keydown.enter="handleEnter"
              />
              <div class="input-buttons-containers">
                <div
                  @click="sendMessage"
                  class="message-input-button"
                  v-html="getRawIcon('PLAY_ICON')"
                >
                </div>
                <div
                  class="upload-icon-container"
                >
                  <label
                    for="messenger-image-upload"
                  >
                    <div
                      v-html="getRawIcon('IMAGE_ICON')"
                      class="message-input-button"
                    >
                    </div>
                  </label>
                  <form class="abstract-upload">
                    <input
                      id="messenger-image-upload"
                      type="file"
                      accept="image/*,video/*"
                      @change="uploadFile"
                    >
                  </form>
                </div>
                <div
                  class="message-input-button"
                >
                  <label
                    for="messenger-file-upload"
                  >
                    <div
                      v-html="getRawIcon('ATTACHMENT_ICON')"
                      class="message-input-button"
                    >
                    </div>
                  </label>
                  <form class="abstract-upload">
                    <input
                      id="messenger-file-upload"
                      type="file"
                      @change="uploadFile"
                    >
                  </form>
                </div>
                <div
                  @click="emojiPicker = true"
                  class="message-input-button"
                  v-html="getRawIcon('EMOJI_ICON')"
                >
                </div>
                <div
                  class="relative"
                >
                  <Transition>
                    <EmojiPicker
                      v-if="emojiPicker"
                      v-click-away="onClickAway"
                      class="emoji-picker"
                      :native="true"
                      @select="onSelectEmoji"
                    />
                  </Transition>
                </div>
              </div>
            </div>
            <div class="message-input-right">
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>
<script>

import {iconStore} from "@/stores/icon";
import {translationStore} from "@/stores/translation";
import {inject, onMounted, onUnmounted, ref, watch} from "vue";
import Axios from "axios";
import FormData from "form-data";
import { io } from "socket.io-client";
import EmojiPicker from 'vue3-emoji-picker'


export default {
    "name": "Messenger",
    "components": {
      EmojiPicker
    },
    "props": {
    },
    setup (props) {

        const translation = translationStore(),
            serverConfig = inject("serverConfig"),
            route = inject("route"),
            router = inject("router"),
            web3 = inject("web3"),
            userInfo = inject("userInfo"),
            socket = io(`wss://${process.env.VUE_APP_DOMAIN}`),
            selectedConversation = ref(),
            icon = iconStore(),
            inputValue = ref(),
            emojiPicker = ref(false),
            sendingFile = ref(false),
            filesInUpload = ref(0),
            messages = ref([]),
            conversationsClass = ref('conversations-desktop'),
            messengerLayout = ref('desktop-layout'),
            messagesLayout = ref('messages-container-desktop'),
            conversations = ref([
            ]),
            users = ref({
            }),
            toggleMessageOptions = function(mid) {

                const m = document.getElementById(mid);
                if (m) {
                    m.hidden = !m.hidden;
                }

            },
            textToLinks = function(text) {

              if (!text) {
                return '';
              }

              const lines = text.split('\n');
              const convertedLines = lines.map(line => {
                const words = line.split(' ');
                const convertedWords = words.map(word => {
                  const escapedWord = word
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;");

                  if (
                    escapedWord.includes('.') &&
                    !escapedWord.endsWith('.') &&
                    /[a-zA-Z0-9]$/.test(escapedWord)
                  ) {
                    return `<a href="${
                      escapedWord.startsWith('http') ? escapedWord : 'http://' + escapedWord
                    }" target="_blank" rel="noopener noreferrer">${escapedWord}</a>`;
                  }

                  return escapedWord;
                });
                return convertedWords.join(' ');
              });

              return convertedLines.join('<br>');

            },
            handleInput = function (e) {

            },
            handleEnter = function (e) {

                if (e.keyCode === 13) {

                    sendMessage();

                }

            },
            onSelectEmoji = (emoji) => {

                if (inputValue.value) {

                    inputValue.value += emoji.i

                } else {

                    inputValue.value = emoji.i

                }

            },
            onClickAway = (event) => {

                emojiPicker.value = false;

            },
            gotoPath = function (t) {

                router.push({"path": `/${t}`}).catch((err) => {

                    throw err;

                });

            },
            getConversations = function (user_id) {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}getConversations`,
                    {

                        "params": {

                        }

                    }
                ).
                    then((response) => {

                        if (response.status === 200) {

                            conversations.value.splice(0);

                            var u = [];

                            conversations.value = response.data;

                            if (route.params.room) {
                                selectedConversation.value = route.params.room;
                            }

                            if (!selectedConversation.value && conversations.value.length > 0) {
                                  selectedConversation.value = conversations.value[0].room_id;
                            }

                            for (var i=0; i<conversations.value.length; i++) {

                                for (var j=0; j<conversations.value[i].users.length; j++) {

                                    if (!u.includes[conversations.value[i].users[j]]) {

                                        u.push(conversations.value[i].users[j]);

                                    }

                                }

                                conversations.value[i].users
                                    = conversations.value[i].users.filter(
                                      user_id => parseInt(user_id) !== userInfo.user_id);

                            }

                            if (u.length > 0) {

                                getUserProfiles(u);

                            }

                        }

                    }).
                    catch((error) => {

                        throw error;

                    });

            },
            getConversationMessages = function (roomId) {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}getRoomMessages`,
                    {

                        "params": {

                            roomId

                        }

                    }
                ).
                    then((response) => {

                        if (response.status === 200) {

                            messages.value = response.data;

                            setTimeout(()=>{

                                const messageSpace = document.getElementById('message-space');
                                messageSpace.scrollTop = messageSpace.scrollHeight;

                            },100);

                        }

                    }).
                    catch((error) => {

                        throw error;

                    });

            },
            getUserProfiles = function (u){

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}getUserProfiles`,
                    {

                        "params": {

                            'users': u

                        }

                    }
                ).
                    then((response) => {

                        if (response.status === 200) {

                            for (var i=0; i<response.data.length; i++) {

                                users.value[response.data[i].user_id] = response.data[i];

                            }

                            if (!route.params.room) {

                                selectedConversation.value = conversations.value[0].room_id;

                            }

                        }

                    }).
                    catch((error) => {

                        throw error;

                    });

            },
            downloadFile = function (file) {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}downloadPrivateFile`,
                    {

                        responseType: "arraybuffer",
                        "params": {

                            path: file.path,
                            filename: file.name

                        }

                    }
                ).
                    then((response) => {

                        if (response.status === 200) {

                            const blob = new Blob([response.data], { type: file.mimeType });

                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = file.name;
                            document.body.appendChild(a);

                            a.click();

                            document.body.removeChild(a);
                            URL.revokeObjectURL(url);

                        }

                });

            },
            uploadFile = function (e) {

                sendingFile.value = true;

                setTimeout(()=> {

                    const messageSpace = document.getElementById('message-space');
                    messageSpace.scrollTop = messageSpace.scrollHeight;

                },100);

                filesInUpload.value++;

                const files = e.target.files;
                const file = files[0];

                const data = new FormData();

                data.append(
                    "file",
                    file
                );

                Axios.post(
                    `${process.env.VUE_APP_SERVER_URI}uploadFile`,
                    data,
                    {

                        "headers": {

                            "Content-Type": "multipart/form-data"

                        }

                    }
                ).
                    then((response) => {

                        filesInUpload.value--;
                        if (filesInUpload.value == 0) {

                            sendingFile.value = false;

                        }

                        if (response.status === 200) {

                            sendMessage({
                                path: response.data.path,
                                name: response.data.name,
                                mimeType: response.data.mimeType,
                                text: "File Upload : " + response.data.name
                            });

                        }

                    }).
                    catch((error) => {

                        throw error;

                    });

            },
            sendMessage = function (msg) {

                let message = {};

                if (msg?.mimeType) {

                    message = msg

                } else if (inputValue.value) {

                    message.text = inputValue.value;

                } else {

                    return;

                }

                if (!selectedConversation.value) {

                    selectedConversation.value = route.params.room;

                }

                const data = {

                    roomId: selectedConversation.value,
                    message

                }

                Axios.post(
                    `${process.env.VUE_APP_SERVER_URI}sendMessage`,
                    data,
                    {

                        "headers": {

                            "Content-Type": "application/json"

                        }

                    }

                ).
                    then((response) => {

                        if (response.status === 200) {

                            inputValue.value = "";

                            setTimeout(()=> {

                                const messageSpace = document.getElementById('message-space');
                                messageSpace.scrollTop = messageSpace.scrollHeight;

                            },100);

                        }

                });

                const index = conversations.value.findIndex(
                  (c) => c.room_id === selectedConversation.value
                );

                if (index === -1) {
                  return;
                }

                const [selected] = conversations.value.splice(index, 1);
                conversations.value = [selected, ...conversations.value];

            },
            deleteMessage = function (messageId) {

                const data = {

                    roomId: selectedConversation.value,
                    type: 'delete',
                    messageId

                }

                Axios.post(
                    `${process.env.VUE_APP_SERVER_URI}sendMessage`,
                    data,
                    {

                        "headers": {

                            "Content-Type": "application/json"

                        }

                    }

                ).
                    then((response) => {

                        if (response.status === 200) {
                        }

                })

            },
            getRawIcon = function (i) {

                return icon.get(`${i}`);

            },
            updateView = function () {

                if (serverConfig.view === "desktop") {

                    conversationsClass.value = 'conversations-desktop'
                    messengerLayout.value = 'desktop-layout'
                    messagesLayout.value = 'messages-container-desktop'

                } else if (serverConfig.view === "tablet") {

                    conversationsClass.value = 'conversations-tablet'
                    messengerLayout.value = 'desktop-layout'
                    messagesLayout.value = 'messages-container-tablet'

                } else {

                    conversationsClass.value = 'conversations-mobile'
                    messengerLayout.value = 'mobile-layout'
                    messagesLayout.value = 'messages-container-mobile'

                }

            };

        onMounted(() => {

            socket.on("connect", () => {

                socket.emit("connection", "hullo");

            });

            socket.on("newMessage", ({userId,roomId,message}) => {

                if (message.action == 'reload') {

                    getConversationMessages(selectedConversation.value);
                    return;

                }

                var newChat = true;

                for (var i in conversations.value) {

                    if (conversations.value[i].room_id == roomId) {

                        conversations.value[i].message = message.message;

                        newChat = false;

                    }

                }

                if (newChat === true) {

                    getConversations();

                } else {

                    if (selectedConversation.value == roomId) {

                        messages.value.push(message);

                    }

                    setTimeout(()=> {

                        const messageSpace = document.getElementById('message-space');
                        messageSpace.scrollTop = messageSpace.scrollHeight;

                    },100);

                }

            });

            setTimeout(()=> {

                updateView();
                getConversations();

            },300);

            socket.on("newChat", ({userId,roomId}) => {

                getConversations();

            });

            watch(
                route.params.room,
                () => {

                    selectedConversation.value = route.params.room;

                }
            );

            watch(
                selectedConversation,
                () => {

                    getConversationMessages(selectedConversation.value);

                },
                { immediate: true }
            );

            watch(
                () => serverConfig.view,
                () => {

                    updateView();

                }
            );

        });

        onUnmounted(() => {

            socket.disconnect();

        });

        return {"localize": translation.localize,
            icon,
            web3,
            route,
            textToLinks,
            getConversations,
            getConversationMessages,
            getUserProfiles,
            toggleMessageOptions,
            conversationsClass,
            messengerLayout,
            messagesLayout,
            sendingFile,
            filesInUpload,
            gotoPath,
            userInfo,
            updateView,
            users,
            emojiPicker,
            onClickAway,
            onSelectEmoji,
            conversations,
            selectedConversation,
            messages,
            uploadFile,
            downloadFile,
            getRawIcon,
            inputValue,
            handleInput,
            handleEnter,
            sendMessage,
            deleteMessage,
            serverConfig,
            "icon": icon.get};

    }
};

</script>
<style scoped>
.file-name {
  color: #22255c;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
  white-space: nowrap;
}
.file-name:hover {
  text-decoration: underline;
}
.messenger-container {
  display: flex;
  flex-direction: column;
  height: 50vh;
  height: calc(100vh - 300px);
  max-width: 1200px;
  width: 100%;
  border-radius: 12px;
  font-family: 'Arial', sans-serif;
  transition: transform 0.2s ease-in-out;
  margin-left: auto;
  margin-right: auto;
}
.conversation-bubble {
  display: flex;
  width: fix-content;
  align-items: center;
  justify-content: start;
  padding: 10px;
  margin: 0px 10px 10px 0px;
  font-size: 1em;
  border-radius: 50px;
  cursor: pointer;
  transition: box-shadow .3s ease;
  box-shadow: 1px 1px 5px rgba(0,0,0,.2);
}
.user-profile-bubble {
  display: flex;
  align-items: center;
  justify-content: center;
}
.conversation-bubble:hover {
  box-shadow: 4px 4px 20px rgba(0,0,0,.3);
}
.conversation-bubble:active {
  box-shadow: 1px 1px 5px rgba(0,0,0,.2);
}
.bubble-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-grow {
  flex-grow: 1;
}
.messages-container-bubble-me {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: end;
  padding: 3px;
  overflow-wrap: anywhere;
}
.messages-container-bubble-other {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 5px;
  overflow-wrap: anywhere;
}
.message-bubble-me {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 3px 10px;
  margin: 0px 15px;
  border-radius: 12px;
  background-color: #349de8;
  color: white;
  width: fit-content;
  cursor: pointer;
}
.message-bubble-other {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 3px 10px;
  margin: 0px 15px;
  border-radius: 12px;
  background-color: #fff;
  color: #333;
  width: fit-content;
}
.messages-container-desktop {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  border-radius: 30px;
  background: #e4e4e4;
}
.messages-container-tablet {
  width: 100%;
  display: flex;
  height: calc(100vh - 200px);
  flex-direction: column;
  justify-content: end;
  border-radius: 30px;
  background: #e4e4e4;
}
.messages-container-mobile {
  width: 100%;
  height: calc(100vh - 290px);
  display: flex;
  flex-direction: column;
  justify-content: end;
  border-radius: 30px;
  background: #efefef;
}
#message-space {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
.profile-image {
  width: 64px;
  height: 64px;
  border: 1px solid #efefef;
  border-radius: 50%;
  background: #efefef;
}
.profile-text {
  margin: 5px 10px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message-options {
  position: absolute;
  padding: 5px;
  margin: -40px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 5px 5px 10px 0px grey;
  color: black;
  cursor: pointer;
}
.message-input-field {
  position: relative;
  display: flex;
  flex-grow: 1;
  font-size: 1em;
  align-items: center;
  margin: 10px;
  padding: 10px 20px;
  line-height: 30px;
  border-radius: 30px;
  height: 30px;
  min-width: 250px;
  outline: none;
  border: none;
}
input:focus {
  outline: none;
}
.message-input-center {
  position: relative;
  display: flex;
  flex-direction: row;
}
.conversations-desktop {
  display: flex;
  flex-direction: column;
  min-width: 260px;
  overflow: auto;
  padding: 15px;
}
.conversations-tablet {
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 120px;
  align-items: center;
}
.conversations-mobile {
  display: flex;
  flex-direction: row;
  overflow: auto;
}
.desktop-layout {
  display: flex;
  height: 100%;
}
.mobile-layout {
  display: flex;
  flex-direction: column;
}
.input-buttons-containers {
  position: absolute;
  right: 0;
  margin-right: 40px;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.message-input-button {
  width: 24px;
  padding: 5px;
  transition: filter 0.2s ease-in-out;
}
.message-input-button:hover {
  cursor: pointer;
  filter: drop-shadow(0 0 10px cyan);
}
.upload-icon-container {
  position: relative
}
.abstract-upload {
  width: 100%;
  height: 100%;
  position: absolute;
}
input#messenger-file-upload {
  display: none;
}
input#messenger-image-upload {
  display: none;
}
.relative {
  position: relative;
}
.emoji-picker {
  position: absolute;
  margin-top: -360px;
  margin-left: -250px;
}
.chat-title {
  padding: 0px 10px;
}
.active-conversation {
  border: 1px solid #349de8;
  width: 100%;
  height: 0px;
}
.sending-file-container {
  display: flex;
  justify-content: end;
  align-items: end;
}
.sending-file-text {
  font-size: 0.8em;
  color: white;
  padding: 3px 10px;
  margin: 0 15px;
  font-weight: bold;
  text-transform: uppercase;
}
.sending-file-background {
  display: flex;
  position: relative;
  width: fit-content;
  height: 100%;
  margin: 5px 17px;
  height: 25px;
  border-radius: 12px;
  animation: gradientMove 6s infinite;
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;
  background: linear-gradient(90deg, #00ffff, #00c9ff, #0099ff, #00c9ff, #00ffff);
  background-size: 400% 400%;
}
@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.message-file-me {
  padding: 3px 2px 2px 11px;
  border: 2px solid dashed #ccc;
  border-radius: 15px;
  cursor: pointer;
  text-align: right;
  margin-right: 10px;
  max-width: 500px;
}
.message-file-other {
  padding: 3px 11px 2px 11px;
  border: 2px solid dashed #ccc;
  border-radius: 15px;
  cursor: pointer;
  margin-right: 10px;
  width: fit-content;
  max-width: 500px;
}
.mime-type {
  margin-right: 10px;
  font-size: 0.75em;
  color: grey;
}
a {
  color: inherit;
  text-decoration: underline;
  background: none;
  border: none;
}
a:hover {
  color: inherit;
  text-decoration: underline;
}

</style>
